import React from 'react'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import styles from './_styles/formStyles'
import { TokTokDocFormProps } from './_props/TokTokDocFormProps'
import TokTokDocSaveButtons from './SaveButtons'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { root: { flexGr... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

export default function TokTokDocForm({
    title,
    edition,
    allowedRoles,
    shouldBlockNavigation,
    deleteActionMessage,
    className,
    allowDelete,
    redirectTo,
    cancelRedirectTo,
    onSave,
    isSaveEnabled = () => true,
    isDeleteEnabled = true,
    onDelete,
    allowCancel = true,
    children,
    isExternal,
    displaySaveComponent,
}: TokTokDocFormProps) {
    const classes = useStyles()
    return (
        <div className={clsx(classes.root, className)}>
            <Grid container spacing={1}>
                <Grid item xs={12} className={classes.topCard}>
                    <Paper className={classes.paper}>
                        <Card className={`no-padding-bottom-card ${classes.root}`}>
                            <CardHeader
                                style={{
                                    textAlign: 'left',
                                    paddingLeft: '10px',
                                    paddingBottom: '10px',
                                }}
                                title={title}
                            />
                            <CardContent>{children}</CardContent>
                        </Card>
                        {displaySaveComponent && (
                            <TokTokDocSaveButtons
                                allowDelete={allowDelete}
                                allowCancel={allowCancel}
                                redirectTo={redirectTo}
                                cancelRedirectTo={cancelRedirectTo}
                                onSave={onSave}
                                isSaveEnabled={() => onSave !== undefined && isSaveEnabled()}
                                isDeleteEnabled={isDeleteEnabled}
                                onDelete={onDelete}
                                edition={edition}
                                allowedRoles={allowedRoles}
                                shouldBlockNavigation={shouldBlockNavigation ?? (() => false)}
                                deleteActionMessage={deleteActionMessage}
                                isExternal={isExternal}
                            />
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}
